// removed by extract-text-webpack-plugin
module.exports = {"loaderWrapper":"loading-screen__loaderWrapper___2cb0O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loading-screen/loading-screen.scss
// module id = 631
// module chunks = 0